import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { bootstrapAuthFromUrl } from './app/core/auth/auth-url-bootstrap';
import { environment } from './environments/environment';

// ⚠️ Reihenfolge: Importe oben, Initialisierung danach. Anweisungen zwischen
// Importe zu mischen täuscht eine Reihenfolge vor, die es nicht gibt -
// JavaScript wertet ALLE Importe aus, bevor die erste Anweisung läuft.

if (environment.production) {
  enableProdMode();
}

// Anmeldeparameter aus der Adresse übernehmen, BEVOR Angular startet und der
// Router die Adresse zum ersten Mal ansieht. Nur so überlebt ein Rücksprung
// auf eine Unterseite: Der Wächter würde sonst umleiten und dabei die
// Suchparameter abschneiden.
bootstrapAuthFromUrl();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
